import { store } from '@context/store';
import HotelApi from '@customTypes/hotel-api';
import { NewGetHotelsV6 } from '@utils/services';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';

export default function useHomePageHotels() {
  const globalState = useContext(store);
  const { state } = globalState;
  const { userLocation } = state;
  const router = useRouter();

  const [homePageHotels, setHomePageHotels] = useState<HotelApi[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetchComplete, setIsFetchComplete] = useState<boolean>(false);

  useEffect(() => {
    const getHotels = async () => {
      try {
        setIsFetchComplete(false);
        setIsLoading(true);
        if (userLocation) {
          const cityId = userLocation.id;
          if (cityId) {
            // -------------------------------------------------------
            // Near City ---------------------------------------------
            // -------------------------------------------------------
            const hotelData = await NewGetHotelsV6(
              {
                searchType: 'city',
                searchValue: cityId,
                stage: 1,
                limit: 16,
              },
              [['closed_for_season:false']],
            );

            setHomePageHotels(hotelData.hotels);
          }
        }
      } catch (error) {
        //
      } finally {
        setIsFetchComplete(true);
        setIsLoading(false);
      }
    };
    if (userLocation && (router.pathname === '/' || router.pathname === '/mastercard')) getHotels();
  }, [router.pathname, userLocation]);

  return {
    homePageHotels,
    isFetchComplete,
    isLoading,
  };
}
